import { QueryKeysEnum } from '@/enums';
import {
  BottleProductEntity,
  BottleProductParams,
  CreateBottleProduct,
  UpdateBottleProduct,
  UpdateManyBottleProduct,
} from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class FmtBottleProductService extends BaseService<
  'fmtBottle',
  BottleProductEntity,
  CreateBottleProduct
> {
  constructor() {
    super(QueryKeysEnum.FMT_BOTTLE);
  }

  getAllBottles = (
    payload: BottleProductParams,
  ): Promise<BottleProductEntity[]> => {
    const params: BottleProductParams = { ...payload, isFetchAll: true };
    return APIService.get(this.path, { params });
  };

  updateBottle = (payload: {
    id: string;
    data: UpdateBottleProduct;
  }): Promise<BottleProductEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };

  updateManyBottles = (
    payload: UpdateManyBottleProduct,
  ): Promise<BottleProductEntity> => {
    return APIService.put(this.path + '/many', payload);
  };
}

export const bottleProductService = new FmtBottleProductService();
